<div class="notification-hub notification-hub--navbar">

  <div class="hub-navbar-header">
    <div>
      <strong>Notifications</strong>
      <span class="hub-badge" *ngIf="tabUnreadCount('all')">{{ tabUnreadCount('all') }} new</span>
    </div>
    <div class="hub-navbar-header__actions">
      <button type="button" class="btn-icon-refresh" (click)="refresh($event)"
        [disabled]="loading" aria-label="Refresh notifications" title="Refresh">
        <i class="feather icon-refresh-cw" [class.spin]="loading"></i>
      </button>
      <button type="button" class="btn-link-sm" (click)="markAllRead($event)" [disabled]="tabUnreadCount(activeCategory === 'all' ? 'all' : activeCategory) === 0">Mark all read</button>
    </div>
  </div>

  <div class="hub-toolbar">
    <div class="hub-tabs">
      <button
        type="button"
        *ngFor="let cat of categories"
        class="hub-tab"
        [class.hub-tab--active]="activeCategory === cat.key"
        (click)="setCategory(cat.key)">
        <span class="hub-tab__label">{{ cat.label }}</span>
        <span class="hub-tab__count" *ngIf="tabUnreadCount(cat.key) > 0">{{ tabUnreadCount(cat.key) }}</span>
      </button>
    </div>
  </div>

  <div class="hub-loading" *ngIf="loading">
    <div class="hub-skeleton" *ngFor="let s of [1,2,3]"></div>
  </div>

  <div class="hub-list" *ngIf="!loading">
    <app-notification-card
      *ngFor="let item of filteredItems; trackBy: trackById"
      [item]="item"
      variant="navbar"
      [attachments]="getAttachments(item)"
      [categoryLabel]="categoryLabel(item.category)"
      [categoryIconName]="categoryIcon(item.category)"
      [priorityLabel]="priorityLabel(item.priority)"
      [relativeTimeLabel]="relativeTime(item.createdAt)"
      (cardClick)="onCardClick(item)"
      (markReadClick)="markRead(item, $event)"
      (previewAttachment)="openAttachmentPreview($event)"
      (downloadAttachment)="downloadAttachmentFile($event)">
    </app-notification-card>

    <div class="hub-load-more" *ngIf="hasMore && filteredItems.length">
      <button type="button" class="btn-link-sm" (click)="loadMore($event)"
        [disabled]="loading || loadingMore">
        {{ loadingMore ? 'Loading…' : 'Load more' }}
      </button>
    </div>

    <div class="hub-empty" *ngIf="!filteredItems.length">
      <div class="hub-empty__icon"><i class="feather icon-bell-off"></i></div>
      <h4>You're all caught up</h4>
      <p>No notifications in this tab.</p>
    </div>
  </div>
</div>
